import accountApiFactory from '../../modules/account/accountApi';

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils';

/* Actions */
import {
  getUserInfoActionCreators,
  setUserInfoActionCreators,
} from '../../redux/actions/accountActions';

function accountSagasFactory({storefrontApiClient}) {
  const accountApi = accountApiFactory(storefrontApiClient);

  const getUserInfoSaga = generateDefaultAsyncSaga(
    accountApi.getUserInfo,
    getUserInfoActionCreators,
    payload => [
      payload.params,
    ]
  );

  const setUserInfoSaga = generateDefaultAsyncSaga(
    () => Promise.resolve(),
    setUserInfoActionCreators,
    payload => [
      payload.params,
    ]
  );

  const watchGetUserInfo = generateDefaultAsyncWatcher(
    'GET_USER_INFO',
    getUserInfoSaga
  );

  const watchSetUserInfo = generateDefaultAsyncWatcher(
    'SET_USER_INFO',
    setUserInfoSaga
  );

  const accountSagas = [
    watchGetUserInfo(),
    watchSetUserInfo(),
  ];

  return accountSagas;
}

export default accountSagasFactory;
